import WrapperLayout from 'components/Layout';
import Main from "./Components/Main"
const LegalMarketplaceEnhanced = () =>{
    return(
        <>
        <WrapperLayout>
            <Main/>
        </WrapperLayout>
    </>
    )
}
export default LegalMarketplaceEnhanced